import { fleetData } from "../../data/fleetData"
import { Vehicle } from "../../types/Vehicle"
import './Fleet.css'
export default function Fleet(){
    return(
        <div className="Fleet">
            {fleetData.map((vehicle : Vehicle) => (
                <div className="FleetCard">
                    <h1 className="fleet-title">{vehicle.name}</h1>
                    <img className="vehicle-image" src={vehicle.image} alt="Company fleet vehicles"/>
                </div>
            ))}
        </div>
    )
}